import { Photo } from "../types/Photo";
import { storage } from "../libs/firebase";
import {
  ref,
  listAll,
  getDownloadURL,
  uploadBytes,
  deleteObject,
} from "firebase/storage";
import { v4 as createId } from "uuid";

export const getAll = async (): Promise<Photo[]> => {
  let list: Photo[] = [];

  const imagesFolder = ref(storage, "images");
  const photoList = await listAll(imagesFolder);

  for (let i in photoList.items) {
    const photoUrl = await getDownloadURL(photoList.items[i]);
    list.push({
      name: photoList.items[i].name,
      url: photoUrl,
    });
  }

  return list;
};

export const insert = async (file: File, name?: string) => {
  if (["image/jpeg", "image/jpg", "image/png"].includes(file.type)) {
    let finalName = name || createId();
    let extension = file.name.split(".").pop();
    let fileName = `${finalName}.${extension}`;

    let newFile = ref(storage, `images/${fileName}`);
    let upload = await uploadBytes(newFile, file);
    let photoUrl = await getDownloadURL(upload.ref);

    return { name: upload.ref.name, url: photoUrl } as Photo;
  } else {
    return new Error("File type not allowed");
  }
};


export const deletePhoto = async (name: string) => {
  let photoRef = ref(storage, `images/${name}`);
  await deleteObject(photoRef);
};
